module.exports = __webpack_public_path__ + "static/media/Assets-01-Vienna-Town-Hall-halftone.c2a4f82c.jpg";